import { render, staticRenderFns } from "./PastEvent.vue?vue&type=template&id=57c0887a"
import script from "./PastEvent.vue?vue&type=script&lang=js"
export * from "./PastEvent.vue?vue&type=script&lang=js"
import style0 from "./PastEvent.vue?vue&type=style&index=0&id=57c0887a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports